import { ChatApi } from "generated/apiChats";
import { Configuration } from "generated/configuration";
import { getLoggedinUser } from "helpers/api_helper";

const { REACT_APP_API_URL } = process.env;

export const fetchLastChats = {
  queryFn: async () => {
    const authUser: any = getLoggedinUser();

    const api = new ChatApi(
      new Configuration({
        accessToken: authUser.accessToken || "",
        basePath: `${REACT_APP_API_URL}`,
      })
    );

    const response = await api.chatControllerFindByUser();
    return response.data;
  },
  queryKey: (data?: any) => ["fetchLastChats", { ...data }],
};


export const fetchMessagesByChat = {
  queryFn: async (id: string) => {
    const authUser: any = getLoggedinUser();

    const api = new ChatApi(
      new Configuration({
        accessToken: authUser.accessToken || "",
        basePath: `${REACT_APP_API_URL}`,
      })
    );

    const response = await api.chatControllerFindMessageByChat(id);
    return response.data;
  },
  queryKey: (data?: any) => ["fetchMessagesByChat", { ...data }],
};
